import { DialogContent, DialogTitle, Divider, Stack, Typography } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { rateCards } from "routes/rate-cards/controller/rate-cards"
import { CurrencyAndRate } from "./currency-and-rate"
import { WorkingTimeFields } from "./working-time-fields"
import { useUniqueNameValidator } from "../use-unique-name-validation"
import { hasInvalidWorkingTime } from "./working-time-validation"

export function RateCardEditDetailsDialog({ currentId, name, description, currency, defaultRate, hoursPerDay }) {
    // status:"all" so the duplicate-name check matches the server (which counts archived too).
    const rcResult = rateCards.useResults({ skip: 0, take: 1000, status: "all" })
    const validateName = useUniqueNameValidator(rcResult?.items, "rate card", { excludeId: currentId })
    return (
        <DataInputDialog
            initialValue={{
                name: name || "",
                description: description || "",
                currency: currency || "GBP",
                defaultRate: defaultRate ?? "",
                hoursPerDay: hoursPerDay ?? "",
            }}
            okCaption="Save"
            startValid
            okDisabled={hasInvalidWorkingTime}
        >
            <DialogTitle sx={{ pb: 3 }}>Edit Rate Card Details</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <BoundTextField field="name" label="Rate Card Name" yup={validateName} autoFocus fullWidth />
                    <BoundTextField
                        field="description"
                        label="Description"
                        placeholder="Optional description..."
                        fullWidth
                        multiline
                        minRows={2}
                    />
                    <Divider />
                    <CurrencyAndRate />
                    <Typography variant="body2" color="text.secondary">
                        Changing the default hourly rate will give you the option to apply it to all trades.
                    </Typography>
                    <Divider />
                    <WorkingTimeFields />
                    <Typography variant="body2" color="text.secondary">
                        Hours per day converts task hours into working days for fixed-contract capacity.
                    </Typography>
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
